<template>
  <div v-if="isButtonVisible">
    <button
      class="btn btn-hover btn-cart"
      :class="added ? 'btn-primary' : data.class"
      @click.prevent="addToCartWishList"
      :disabled="isDisabled"
    >{{ buttonlabel }}</button>
    <div class="modal-cart" v-show="showModal">
      <div v-if="isDisabled">
        <h4>{{ label_adding_to_cart }}</h4>
      </div>
      <div v-if="!isDisabled">
        <h4>{{ label_added_to_cart }}</h4>

        <a :href="netsuite_url + 'cart'" target="_blank"
           class="btn btn-hover btn-primary btn-cart" @click="showModal = false"
        >{{ label_view_cart }}</a>

        <a class="close btn btn-hover btn-primary btn-wishlist" @click.prevent="showModal = false">{{ label_continue_shopping }}</a>
      </div>
    </div>
    <div class="modal-bg" v-show="showModal"></div>
  </div>
</template>

<script>
import { getCartUrl } from "../../store/modules/helpers";
import addToCartMixin from "../../mixins/addToCartMixin";

export default {
  name: "add-to-cart-standalone-multiple",
  mixins: [addToCartMixin],
  props: {
    items: {},
    data: {},
    netsuite_url: {},
    netsuite_app_url: {},
    label_add_to_cart: {
      type: String,
      default: "Add to Cart"
    },
    label_added_to_cart: {
      type: String,
      default: "Added to Cart"
    },
    label_adding_to_cart: {
      type: String,
      default: "Adding to Cart"
    },
    label_view_cart: {
      type: String,
      default: "View Cart"
    },
    label_continue_shopping: {
      type: String,
      default: "Continue Shopping"
    },
    country: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      cartmode: false,
      isDisabled: false,
      added: false,
      currency: window.currency,
      showModal: false,
      item: null,
      apiData: null,
    };
  },
  mounted() {
    this.fetchProductDetails();
  },
  methods: {
    async addToCartWishList() {
      this.showModal = true;
      
      // Add multiple quantities
      for (let i = 0; i < this.data.quantities; i++) {
        try {
          const cartItems = await this.getPackageComponents();
          this.addItemTocart(cartItems);
        } catch (error) {
          // Error already handled in getPackageComponents
          if (i === 0) {
            this.showModal = false;
          }
          break;
        }
      }
    },
    async fetchProductDetails() {
        let data = await axios.get(this.cartUrl, { withCredentials: true });
        this.apiData = data;

    }
  },
  computed: {
    cartUrl() {
      return getCartUrl(this.netsuite_url, this.data.netSuiteId, this.components, true);
    },
    components() {
      let components = [];

      if(this.items && this.items.length > 0) {
          components = this.items.map( c => c.netSuiteId);
      }

      components.push(this.data.netSuiteId);

      return components;
    },
    isButtonVisible() {
      let components, netSuiteId, isAlwaysInStock;

      if(this.apiData) {
          components = this.apiData.data.items;
          netSuiteId = this.data.netSuiteId;
          isAlwaysInStock = this.data.isAlwaysInStock;

          return this.$store.getters["cart/isAddToCartButtonVisible"](components, netSuiteId, isAlwaysInStock);
      }

      return false;
    },
    cartUrlParams() {
      return this.$store.getters["cart/getCartUrlParams"] ?? '';
    },
  }
};
</script>

<style>
.modal-cart {
  background: #fff;
  width: 300px;
  height: auto;
  text-align: center;
  position: fixed;
  top: 50%;
  margin-top: -50px;
  left: 50%;
  margin-left: -100px;
  line-height: 25px;
  z-index: 100001;
  padding: 15px;
}
.modal-cart .close,
.modal-cart .close:hover {
  cursor: pointer;
}
.modal-bg {
  background-color: rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  filter: alpha(opacity=20);
  zoom: 1;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100000;
}
</style>
